<template>
  <div class="pa-2">
    <v-row>
      <v-col cols="12" lg="6">
        <Markets @rowSelected="rowSelected($event)" />
      </v-col>
      <v-col cols="12" lg="6">
        <MarketSubstances :MktID="mktId" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Markets from "./Markets.vue";
import MarketSubstances from "./MarketSubstances.vue";

export default {
  name: "MarketsVG",
  components: {
    Markets,
    MarketSubstances,
  },
  data() {
    return {
      mktId: 0,
    };
  },
  methods: {
    rowSelected(rows) {
      this.mktId = rows && rows.length > 0 ? rows[0].MktID : 0;
    },
  },
};
</script>
